export class LSHelper {
    public static set(key: string, value: any) {
        let itemToSet;
        const existingItem = LSHelper.get(key);

        if (!!existingItem) {
            itemToSet = JSON.parse(existingItem);
            itemToSet.push(value);
        } else {
            itemToSet = [value];
        }

        localStorage.setItem(key, JSON.stringify(itemToSet));
    }

    public static reSet(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    public static get(key: string) {
        return localStorage.getItem(key);
    }

    public static getJSON(key: string) {
        let text = LSHelper.get(key);
        return text && JSON.parse(text);
    }

    public static filter<T>(key: string, filter: (val: T, index?: number, array?: T[]) => boolean) {
        const existingItem = LSHelper.get(key);
        if (!existingItem) {
            return;
        }
        let items: T[] = JSON.parse(existingItem);

        items = items.filter((x, i, a) => filter(x, i, a));
        localStorage.setItem(key, JSON.stringify(items));
    }

    public static remove(key: string) {
        return localStorage.removeItem(key);
    }

    public static setItem(key: string, value: string) {
        return localStorage.setItem(key, value);
    }
}
